// extracted by mini-css-extract-plugin
export default {"container":"taglist_container__aA6-H","tag":"taglist_tag__Bze78"};